module.exports = __webpack_public_path__ + "img/cp-9.a3a1aaa8.jpg";